import React, { } from 'react';
// import './FormComponent.scss';

import {
    Switch,
    FormControl,
    FormHelperText,
} from '@mui/material';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import CustomExclamationHover from './CustomExclamationHover';
import { CustomSwitchInterface } from '../../Models/Common/FormFieldComponentInterfaces';

type BtnColorTypes = { [K in ButtonType]: {
    type: K,
    background: string,
} };
const BtnColors: BtnColorTypes = {
    [ButtonType.PRIMARY]: {
        type: ButtonType.PRIMARY,
        background: "var(--textInfoColor) !important",
    },
    [ButtonType.PRIMARY_LIGHT]: {
        type: ButtonType.PRIMARY_LIGHT,
        background: "var(--fieldSwitchedCheckedBGSecondaryColor) !important",
    },
    [ButtonType.SUCCESS]: {
        type: ButtonType.SUCCESS,
        background: "var(--fieldSwitchedCheckedBGSuccessColor) !important",
    },
    [ButtonType.SUCCESS_LIGHT]: {
        type: ButtonType.SUCCESS_LIGHT,
        background: "var(--buttonBGSuccessLightColor) !important",
    },
    [ButtonType.SECONDARY]: {
        type: ButtonType.SECONDARY,
        background: "transparent",
    },
    [ButtonType.DELETE]: {
        type: ButtonType.DELETE,
        background: "var(--fieldSwitchedCheckedBGDangerColor) !important",
    },
    [ButtonType.WARNING]: {
        type: ButtonType.WARNING,
        background: "var(--textWarningColor) !important",
    },
    [ButtonType.PREV_NEXT]: {
        type: ButtonType.PREV_NEXT,
        background: "var(--fieldSwitchedCheckedBGCancelColor) !important",
    },
    [ButtonType.WHITE]: {
        type: ButtonType.WHITE,
        background: "var(--fieldSwitchedCheckedBGCancelColor) !important",
    },
    [ButtonType.DELETE_LIGHT]: {
        type: ButtonType.DELETE_LIGHT,
        background: "var(--fieldSwitchedCheckedBGDangerColor) !important",
    },
    [ButtonType.CANCEL]: {
        type: ButtonType.CANCEL,
        background: "var(--buttonIconCancelColor) !important",
    },
    [ButtonType.CANCEL_LIGHT]: {
        type: ButtonType.CANCEL_LIGHT,
        background: "var(--buttonIconCancelColor) !important",
    },
    [ButtonType.PRIMARY_NO_BG]: {
        type: ButtonType.PRIMARY_NO_BG,
        background: "var(--textInfoColor) !important",
    },
}

const CustomSwitch = (fieldProps: CustomSwitchInterface) => {
    //Variables

    //Rendering UIs
    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;
    let hideFormFieldLabel = fieldProps.hideLabel ?? false;
    // if (fieldProps.subLabel && fieldProps.subLabel)
    //     hideFormFieldLabel = true;
    const switchType = fieldProps.switchType ?? ButtonType.PRIMARY;

    const renderSwitch = () => {
        return <FormControl error={errorMsg != null} variant="standard" style={{ display: 'flex', justifyContent: 'start', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }} className="switchFormContainer">
                <Switch {...{
                    sx: {
                        "&.MuiSwitch-root .MuiSwitch-switchBase": {
                            color: BtnColors[switchType].background
                        },

                        "&.MuiSwitch-root .Mui-checked": {
                            color: "var(--fieldSwitchedCheckedBGSecondaryColor)"
                        }
                    },
                    value: fieldProps.fieldValue,
                    disabled: fieldProps.disabled,
                    checked: fieldProps.fieldValue,
                    onChange: (e: any) => { fieldProps.handleOnChange(e.target.checked) },
                }} />


                {/* ---------LABEL---------- */}
                {fieldProps.title && !fieldProps.hideLabel &&
                    <div className="switchSideLabel" style={{ fontSize: '0.9rem' }}>
                        {fieldProps.title}
                        {fieldProps.exclamationHoverItemDisplayText &&
                            <CustomExclamationHover hoverText={fieldProps.exclamationHoverItemDisplayText ?? ''} />
                        }
                    </div>}

            </div>
            {/* ---------ERROR---------- */}
            <FormHelperText style={{ marginLeft: '5px' }}>{errorMsg}</FormHelperText>
        </FormControl >
    }

    return <div className="customSwitchContainer" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* {!hideFormFieldLabel && <CustomFormTitle title={fieldProps.title}
            required={fieldProps.required}
            hideLabel={hideFormFieldLabel}
            exclamationHoverItemDisplayText={fieldProps.exclamationHoverItemDisplayText} />} */}

        {/* ---------SWITCH---------- */}
        {renderSwitch()}
    </div>
}

export default CustomSwitch;

